import { Component } from '@angular/core';
import { ORCIDFundingExternalIDEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Funding External IDs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidfundingexternalid-form',
    templateUrl: './orcidfundingexternalid.form.component.html'
})
export class ORCIDFundingExternalIDFormComponent extends BaseFormComponent {
    public record!: ORCIDFundingExternalIDEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

